import type { TooltipItemPositionSelector } from '@mui/x-charts/internals';

// Todo: to implement
export const selectorTooltipItemPosition: TooltipItemPositionSelector<'radialLine'> = () => null;
